import React from 'react';
import {uid} from 'react-uid';
import {motion} from 'framer-motion';
import {Box, Embed} from '@tenancy.nz/design-system';

import LeftRightContent from '../../components/LeftRightContent';
import Markdown from '../../components/Markdown';
import Title from '../../components/Title';

import sections from '../../json/privacy_policy';

function PrivacyPolicyFeature() {
  const sectionVariants = {
    offscreen: {
      // y: 50,
      // opacity: 0,
    },
    onscreen: {
      // y: 0,
      // opacity: 1,
      // transition: {
      //   type: 'spring',
      //   bounce: 0.4,
      //   duration: 0.8,
      // },
    },
  };

  return (
    <>
      <Title text="Privacy Policy - Tenant Portal" />
      <Box width="100%" marginTop="50px">
        <Embed src="https://player.vimeo.com/video/442875704" width="100%" />
      </Box>
      <LeftRightContent
        bgcolor="light"
        heading="Privacy Policy"
        content={sections.map((section, i) => (
          <motion.section
            key={uid({section}, i)}
            initial="offscreen"
            whileInView="onscreen"
            viewport={{
              once: true,
            }}
            variants={sectionVariants}>
            <Markdown>{section}</Markdown>
          </motion.section>
        ))}
      />
    </>
  );
}

export default PrivacyPolicyFeature;
